var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup55(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 183.03,
    height: 114.729,
    viewBox: "0 0 183.03 114.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(91.023 -2103.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M1090.576,1103.958l-17.075,17.075-17.076-17.075-16.883,17.075-17.075-17.075L965.1,1161.323l57.365,57.364,17.075-17.075,17.075,17.075,17.076-17.075,17.075,17.075,57.364-57.364Zm-33.959,9.784,12.087,12.087-12.087,12.087-12.087-12.087Zm13.622,47.581-13.622,13.621L1043,1161.323l13.621-13.622Zm-47.772,47.58-47.58-47.58,47.58-47.58,12.087,12.086-35.493,35.494,35.493,35.493Zm-13.622-47.58,30.7-30.7,12.087,12.087-18.61,18.61,18.418,18.418-12.087,12.087Zm47.772,47.772-12.087-12.087,12.087-12.087,12.087,12.087Zm4.8-29.162,18.61-18.61-18.418-18.419,12.087-12.086,30.7,30.7-30.7,30.7Zm16.883,16.883,35.493-35.493-35.3-35.494,12.087-12.086,47.58,47.58-47.58,47.58Z",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup55);
export default __webpack_public_path__ + "static/media/Group 55.6c0e2d95e97c241b467a190aa0edba1d.svg";
export { ForwardRef as ReactComponent };